export default "__VITE_ASSET__10d9d2fa__"